import { bulkImportApi } from '../api/modules/bulkImport.api';
import { getApiErrorMessage } from '../api/client';
import { downloadExcelResponse, exportFileStamp } from '../utils/exportExcel';

function readFileAsBase64(file) {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onload = () => {
      resolve(String(reader.result || ''));
    };
    reader.onerror = () => reject(new Error('Failed to read file'));
    reader.readAsDataURL(file);
  });
}

export async function downloadEquipmentTypesImportTemplate() {
  try {
    const response = await bulkImportApi.downloadEquipmentTypesTemplate();
    return downloadExcelResponse(
      response,
      `equipment_types_import_template_${exportFileStamp()}.xlsx`,
    );
  } catch (error) {
    throw new Error(
      getApiErrorMessage(error, 'Failed to download import template'),
    );
  }
}

export async function validateEquipmentTypesImport(file) {
  if (!file) throw new Error('Please choose an Excel file');
  try {
    const fileBase64 = await readFileAsBase64(file);
    return await bulkImportApi.validateEquipmentTypes(fileBase64);
  } catch (error) {
    throw new Error(
      getApiErrorMessage(error, 'Failed to validate import file'),
    );
  }
}

export async function commitEquipmentTypesImport(rows) {
  if (!Array.isArray(rows) || rows.length === 0) {
    throw new Error('No rows to import');
  }
  try {
    return await bulkImportApi.commitEquipmentTypes(rows);
  } catch (error) {
    throw new Error(getApiErrorMessage(error, 'Failed to add equipment types'));
  }
}

export async function downloadBuSitesImportTemplate() {
  try {
    const response = await bulkImportApi.downloadBuSitesTemplate();
    return downloadExcelResponse(
      response,
      `bu_sites_import_template_${exportFileStamp()}.xlsx`,
    );
  } catch (error) {
    throw new Error(
      getApiErrorMessage(error, 'Failed to download BU / sites template'),
    );
  }
}

export async function validateBuSitesImport(file) {
  if (!file) throw new Error('Please choose an Excel file');
  try {
    const fileBase64 = await readFileAsBase64(file);
    return await bulkImportApi.validateBuSites(fileBase64);
  } catch (error) {
    throw new Error(
      getApiErrorMessage(error, 'Failed to validate BU / sites file'),
    );
  }
}

export async function commitBuSitesImport(payload) {
  try {
    return await bulkImportApi.commitBuSites(payload);
  } catch (error) {
    throw new Error(
      getApiErrorMessage(error, 'Failed to add business units / sites'),
    );
  }
}

export async function downloadUsersImportTemplate() {
  try {
    const response = await bulkImportApi.downloadUsersTemplate();
    return downloadExcelResponse(
      response,
      `users_import_template_${exportFileStamp()}.xlsx`,
    );
  } catch (error) {
    throw new Error(
      getApiErrorMessage(error, 'Failed to download users template'),
    );
  }
}

export async function validateUsersImport(file) {
  if (!file) throw new Error('Please choose an Excel file');
  try {
    const fileBase64 = await readFileAsBase64(file);
    return await bulkImportApi.validateUsers(fileBase64);
  } catch (error) {
    throw new Error(getApiErrorMessage(error, 'Failed to validate users file'));
  }
}

export async function commitUsersImport(payload) {
  try {
    return await bulkImportApi.commitUsers(payload);
  } catch (error) {
    throw new Error(getApiErrorMessage(error, 'Failed to save users'));
  }
}

export async function downloadUserEquipmentImportTemplate() {
  try {
    const response = await bulkImportApi.downloadUserEquipmentTemplate();
    return downloadExcelResponse(
      response,
      `user_equipment_import_template_${exportFileStamp()}.xlsx`,
    );
  } catch (error) {
    throw new Error(
      getApiErrorMessage(error, 'Failed to download user equipment template'),
    );
  }
}

export async function validateUserEquipmentImport(file) {
  if (!file) throw new Error('Please choose an Excel file');
  try {
    const fileBase64 = await readFileAsBase64(file);
    return await bulkImportApi.validateUserEquipment(fileBase64);
  } catch (error) {
    throw new Error(
      getApiErrorMessage(error, 'Failed to validate user equipment file'),
    );
  }
}

export async function commitUserEquipmentImport(payload) {
  try {
    return await bulkImportApi.commitUserEquipment(payload);
  } catch (error) {
    throw new Error(
      getApiErrorMessage(error, 'Failed to save user equipment'),
    );
  }
}
